import { useState } from 'react'
import Carousel from 'react-bootstrap/Carousel'

import 'bootstrap/dist/css/bootstrap.css'
import styles from './main.module.scss'

import { USE_TERMS } from '../../constants'
import { UseTerms } from '../../components/UseTerms'
import { Storage } from '../../constants/Enum'

import { Modal } from '../../components/Modal'
import { Blog } from './blog'
import { PeFriend } from './pe-friend'
import { Scholarships } from './scholarships'
import { PathInformation } from './path-information'
import { SearchCourse } from './searchCourse'
import { Capitalize } from './capitalize-form'

export default function MainPage() {
  const [category, setCategory] = useState('2')
  const [showModal, setShowModal] = useState(false)
  const [showTerms, setShowTerms] = useState(true)

  const acceptedUseTerms =
    localStorage.getItem(Storage.acceptedUseTerms) === 'accepted'

  const handleAcceptTerms = (accepted: boolean) => {
    const accept = accepted ? 'accepted' : 'noAccepted'
    localStorage.setItem(Storage.acceptedUseTerms, accept)
    setShowModal(false)
    setShowTerms(false)
  }

  return (
    <div className={styles.mainContainer}>
      {!acceptedUseTerms && showTerms && (
        <UseTerms
          openTerms={() => setShowModal(true)}
          handleAcceptTerms={handleAcceptTerms}
        />
      )}

      {showModal && (
        <Modal.Root title="Termos de uso" content={USE_TERMS}>
          <Modal.ButtonRoot>
            <Modal.Button
              labelText="Não concordo"
              handleClickButton={() => handleAcceptTerms(false)}
            />
            <Modal.Button
              labelText="Concordo"
              handleClickButton={() => handleAcceptTerms(true)}
              isPrimary
            />
          </Modal.ButtonRoot>
        </Modal.Root>
      )}

      <div className={styles.caroussel}>
        <Carousel>
          <Carousel.Item>
            <img src="img1.png" alt="Image One" />
          </Carousel.Item>
          <Carousel.Item>
            <img src="img2.png" alt="Image Two" />
          </Carousel.Item>
          <Carousel.Item>
            <img src="img3.png" alt="Image Tree" />
          </Carousel.Item>
          <Carousel.Item>
            <img src="img4.png" />
          </Carousel.Item>
        </Carousel>
      </div>

      <SearchCourse category={category} setCategory={setCategory} />

      <PathInformation />

      <Scholarships category={category} />

      <PeFriend />

      <Blog />

      <Capitalize />
    </div>
  )
}
